import { Component, OnInit, inject } from '@angular/core';
import {environment} from "../../environments/environment";
import {DataService} from "../services/data.service";
import {LocalStorageService} from "../services/local-storage.service";
import {Router, RouterLink, RouterLinkActive} from "@angular/router";
import {AccessService} from "../services/access.service";
import { ThemeService } from '../services/theme.service';
import {Right} from "../interfaces";

@Component({
    selector: 'app-sidebar',
    imports: [RouterLink, RouterLinkActive],
    styles: `
        .sidebar {
            position: fixed;
            top: 0;
            bottom: 0;
            left: 0;
            z-index: 1050; /* Above the navbar */
            box-shadow: inset -1px 0 0 rgba(0, 0, 0, .1);
            width: 260px;
            background: #fafafa;
        }

        @media (max-width: 767.98px) {
            .sidebar {
                top: 57px;
                width: 100%;
                right: 0;
                box-shadow: none;
            }

            /* Hide brand area inside the sidebar on mobile */
            #sidebarMenu .navbar-brand {
                display: none;
            }

            .sidebar .nav-link {
                font-size: 1.125rem; /* larger font on mobile */
                padding-top: 0.5rem;
                padding-bottom: 0.5rem;
            }

            .sidebar-heading {
                font-size: 0.95rem; /* slightly larger section heading */
            }

            #sidebarMenu .navbar-brand h5 {
                font-size: 1.25rem;
            }

            #sidebarMenu .navbar-brand small {
                font-size: 1rem !important; /* override inline small font */
            }

            .sidebar-sticky {
                height: calc(100vh - 5rem);
            }
        }

        .sidebar-sticky {
            height: calc(100vh - 48px);
            overflow-x: hidden;
            overflow-y: auto; /* Scrollable contents if viewport is shorter than content. */
        }

        .sidebar .nav-link {
            font-weight: 500;
            color: #333;
        }

        .sidebar .nav-link.active {
            color: var(--primary);
        }

        .sidebar-heading {
            font-size: .75rem;
        }
    `,
    template: `
        <nav id="sidebarMenu" class="d-md-block bg-light sidebar collapse">
            <div class="position-sticky pt-3 sidebar-sticky">
                <a class="navbar-brand me-0 mb-3 pe-3 fs-6" [routerLink]="['/dashboard']" style="padding-top: 7px; padding-bottom: 8px; width: 250px">
                    <div class="d-flex">
                        <div class="flex-shrink-0">
                            <img [src]="'assets/img/favicon/' + accessService.client.slug + '/android-chrome-192x192.png'" alt="Logo" class="ms-3" style="height: 44px">
                        </div>
                        <div class="flex-grow-1 ms-3">
                            <h5 class="fw-bold mb-0">{{ accessService.client.name }}</h5>
                            <small class="text-muted" style="font-size: 0.8rem">Management Cockpit</small>
                        </div>
                    </div>
                </a>

                <h6 class="sidebar-heading d-flex justify-content-between align-items-center px-3 mb-2 ms-3 text-muted">
                    <span>Hauptmenü</span>
                </h6>

                <ul class="nav flex-column ms-3">
                    <li class="nav-item">
                        <a class="nav-link" [routerLink]="['/dashboard']" (click)="hide()" routerLinkActive="active">
                            <i class="fa-solid fa-house me-2"></i>Dashboard
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" [routerLink]="['/turnover']" (click)="hide()" routerLinkActive="active">
                            <i class="fa-solid fa-money-bill me-2"></i>Umsätze
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" [routerLink]="['/kpi']" (click)="hide()" routerLinkActive="active">
                            <i class="fa-solid fa-gauge-high me-2"></i>KPIs
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" [routerLink]="['/invoice']" (click)="hide()" routerLinkActive="active">
                            <i class="fa-solid fa-file-invoice me-2"></i>Rechnungen
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" [routerLink]="['/maps']" (click)="hide()" routerLinkActive="active">
                            <i class="fa-solid fa-globe me-2"></i>Karte
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" [routerLink]="['/report']" (click)="hide()" routerLinkActive="active">
                            <i class="fa-solid fa-file-pdf me-2"></i>Berichte
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" [routerLink]="['/productevaluation']" (click)="hide()" routerLinkActive="active">
                            <i class="fa-solid fa-chart-simple me-2"></i>Detailauswertung
                        </a>
                    </li>
                </ul>

                @if (accessService.hasRight(Right.MANAGE_MASTER_DATA)) {
                    <h6 class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-2 ms-3 text-muted">
                        <span>Stammdaten</span>
                    </h6>

                    <ul class="nav flex-column ms-3 mb-auto">
                        <li class="nav-item">
                            <a class="nav-link" [routerLink]="['/store']" (click)="hide()" routerLinkActive="active">
                                <i class="fa-solid fa-store me-2"></i>Stores
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" [routerLink]="['/franchisee']" (click)="hide()" routerLinkActive="active">
                                <i class="fa-solid fa-handshake me-2"></i>Franchisenehmer
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" [routerLink]="['/franchisor']" (click)="hide()" routerLinkActive="active">
                                <i class="fa-solid fa-building me-2"></i>Franchisegeber
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" [routerLink]="['/product']" (click)="hide()" routerLinkActive="active">
                                <i class="fa-solid fa-boxes-stacked me-2"></i>Produkte
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" [routerLink]="['/productgroup']" (click)="hide()" routerLinkActive="active">
                                <i class="fa-solid fa-box me-2"></i>Produktgruppen
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" [routerLink]="['/productcheck']" (click)="hide()" routerLinkActive="active">
                                <i class="fa-solid fa-square-check me-2"></i>Produktabgleich
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" [routerLink]="['/country']" (click)="hide()" routerLinkActive="active">
                                <i class="fa-solid fa-globe me-2"></i>Länder
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" [routerLink]="['/position']" (click)="hide()" routerLinkActive="active">
                                <i class="fa-solid fa-location-dot me-2"></i>Lagen
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" [routerLink]="['/region']" (click)="hide()" routerLinkActive="active">
                                <i class="fa-solid fa-map me-2"></i>Regionen
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" [routerLink]="['/user']" (click)="hide()" routerLinkActive="active">
                                <i class="fa-solid fa-users me-2"></i>Benutzer
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" [routerLink]="['/invoicetype']" (click)="hide()" routerLinkActive="active">
                                <i class="fa-solid fa-file-invoice me-2"></i>Rechnungskreise
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" [routerLink]="['/pricelist']" (click)="hide()" routerLinkActive="active">
                                <i class="fa-solid fa-table-list me-2"></i>Preislisten
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" [routerLink]="['/supplier']" (click)="hide()" routerLinkActive="active">
                                <i class="fa-solid fa-boxes-packing me-2"></i>Lieferanten
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" [routerLink]="['/supplierproduct']" (click)="hide()" routerLinkActive="active">
                                <i class="fa-solid fa-box-open me-2"></i>Lieferantenprodukte
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" [routerLink]="['/supplierpricelist']" (click)="hide()" routerLinkActive="active">
                                <i class="fa-solid fa-table-list me-2"></i>Lieferantenpreislisten
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" [routerLink]="['/contactcategory']" (click)="hide()" routerLinkActive="active">
                                <i class="fa-solid fa-address-book me-2"></i>Kontaktkategorien
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" [routerLink]="['/contact']" (click)="hide()" routerLinkActive="active">
                                <i class="fa-solid fa-id-card me-2"></i>Kontakte
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" [routerLink]="['/list']" (click)="hide()" routerLinkActive="active">
                                <i class="fa-solid fa-rectangle-list me-2"></i>Diverse Listen
                            </a>
                        </li>
                    </ul>
                }

                <!-- Mobile-only user section -->
                <div class="d-lg-none border-top mt-3 pt-3 pb-3 px-3">
                    <div class="d-flex align-items-center justify-content-between mb-2">
                        <div class="me-2">
                            <div class="small text-muted">Angemeldet als</div>
                            <div class="fw-semibold">{{ accessService.user?.firstname }} {{ accessService.user?.lastname }}</div>
                        </div>
                        <h6 class="mb-0"><span class="badge text-bg-secondary">v{{ currentApplicationVersion }}</span></h6>
                    </div>
                    <div class="d-grid gap-2">
                        <button class="btn btn-sm" type="button" title="Design umschalten"
                                (click)="toggleTheme()"
                                [class.btn-primary]="isDarkMode"
                                [class.btn-outline-secondary]="!isDarkMode">
                            <i class="fa" [class.fa-sun]="isDarkMode" [class.fa-moon]="!isDarkMode"></i>
                            <span class="ms-1">{{ isDarkMode ? 'Hell' : 'Dunkel' }}</span>
                        </button>
                        <button class="btn btn-outline-secondary" type="button" (click)="logout(); hide()">Abmelden</button>
                    </div>
                </div>
            </div>
        </nav>
    `
})
export class SidebarComponent implements OnInit {

    accessService = inject(AccessService);
    private dataService = inject(DataService);
    private localStorageService = inject(LocalStorageService);
    private router = inject(Router);
    private themeService = inject(ThemeService);

    currentApplicationVersion = environment.appVersion;

    ngOnInit(): void {
        // Theme is initialized by ThemeService
    }

    get isDarkMode(): boolean {
        return this.themeService.isDarkMode;
    }

    toggleTheme(): void {
        this.themeService.toggleTheme();
    }

    hide(): void {
        const element = document.getElementById('sidebarMenu');
        if (element && element.classList.contains('show')) {
            element.classList.remove('show');
        }
    }

    logout(): void {
        this.dataService.request("User/logout").subscribe(() => {
            this.localStorageService.removeItem('token');
            this.accessService.token = '';
            this.accessService.user = null;
            this.router.navigate(['/login']);
        });
    }

    protected readonly environment = environment;
    protected readonly Right = Right;
}
